import { createFileRoute, useRouterState } from '@tanstack/react-router';
import { AjudaPage } from '@/components/ajuda';

export const Route = createFileRoute('/_app/ajuda')({
  validateSearch: (bruto: Record<string, unknown>) => ({
    p: typeof bruto.p === 'string' && bruto.p.length > 0 ? bruto.p : undefined,
  }),
  component: AjudaRota,
});

function AjudaRota() {
  const { p } = Route.useSearch();
  const navigate = Route.useNavigate();
  const hash = useRouterState({ select: (s) => s.location.hash });
  return (
    <AjudaPage
      slug={p ?? 'indice'}
      ancora={hash.replace(/^#/, '') || undefined}
      aoAbrirPagina={(slug, ancora) => void navigate({ to: '/ajuda', search: { p: slug }, hash: ancora })}
    />
  );
}
